// framework
import React, { useState, useCallback } from "react";
// constants
import { IMAGES, MESSAGES } from "constants/constants";
// styles
import styles from "./StartGameView.module.scss";
// components
import Button from "components/Shared/Button/Button";
import Player from "components/Shared/Player/Player";

const START_BUTTON_TIMEOUT_MS = 3000;

export default function StartGameView({ player, room }) {
    const [isStarting, setIsStarting] = useState(false);

    const onStart = useCallback(() => {
        if (!room || isStarting) return;

        room.send(MESSAGES.TO_SERVER.PLAYER_START_GAME, {});
        setIsStarting(true);

        setTimeout(() => {
            setIsStarting(false);
        }, START_BUTTON_TIMEOUT_MS);
    }, [room, isStarting]);

    return (
        <div className={styles.startGameView}>
            {/*<img src={IMAGES.CLIENT.mdmdLogo} alt="Million Dollar Money Drop" className={styles.logo} />*/}
            <Player className={styles.player} player={player} room={room} />
            <div className={styles.buttons}>
                <Button onClick={onStart} disabled={isStarting} className={styles.button}>
                    {isStarting ? "Starting..." : "Start Game"}
                </Button>
            </div>
        </div>
    );
}